export default __webpack_public_path__ + "static/media/martin_metrovias.4fd7e75f.jpg";